import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { createQueryClient } from "./lib/queryClient";
import { SessionProvider } from "./lib/session";
import "./styles/global.css";

const root = document.getElementById("root");
// A missing root element is a broken build, not a runtime condition to handle
// gracefully — failing loudly here is what makes it obvious in one look.
if (root === null) throw new Error("#root is missing from the document");

const queryClient = createQueryClient();

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Inside the query provider: the session is itself a query. */}
      <SessionProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SessionProvider>
    </QueryClientProvider>
  </StrictMode>,
);
